'use client';

import { createContext, ReactNode, useContext } from 'react';

export type FormStatus = 'consultation' | 'edition' | 'creation';

const FormStatusContext = createContext<FormStatus>('creation');

export const useFormStatus = () => useContext(FormStatusContext);

export const FormStatusProvider = ({
  status,
  children,
}: {
  status: FormStatus;
  children: ReactNode;
}) => <FormStatusContext value={status}>{children}</FormStatusContext>;
